import { render, staticRenderFns } from "./UsabilitySection.vue?vue&type=template&id=0de670d8&scoped=true&"
import script from "./UsabilitySection.vue?vue&type=script&lang=js&"
export * from "./UsabilitySection.vue?vue&type=script&lang=js&"
import style0 from "./UsabilitySection.vue?vue&type=style&index=0&id=0de670d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de670d8",
  null
  
)

export default component.exports